<template>
  <div class="about-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">About Us</span>
        <span class="page-subtitle">Learn more about Medicater</span>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-state" v-if="loading">
      <div class="spinner"></div>
      <span>Loading…</span>
    </div>

    <!-- Empty state -->
    <div class="empty-state" v-if="!loading && !content">
      <div class="empty-icon-wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      </div>
      <p class="empty-title">No content available</p>
      <p class="empty-sub">Check back later for more information.</p>
    </div>

    <!-- Content -->
    <div class="section-pad" v-if="!loading && content">
      <div class="content-card">
        <div class="prose" v-html="content"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'about',
  data: function () {
    return {
      content: '',
      loading: true
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    var that = this

    $.ajax({
      beforeSend: function (xhr) {
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      url: 'https://admin.medicater.co.za/api/content/content?content=about_us',
      type: 'get',
      success: function (data) {
        that.loading = false
        that.content = data.data.copy
      },
      error: function () {
        that.loading = false
      }
    })
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255, 255, 255, 0.25); }

.header-info { display: flex; flex-direction: column; gap: 3px; }

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
}

/* ── Loading ── */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 120px 16px 40px;
  color: #94a3b8;
  font-size: 0.875rem;
}

.spinner {
  position: relative;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #1a587b;
  border-left-color: #1a587b;
  animation: spin 0.9s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}
.spinner::after {
  content: '';
  position: absolute;
  inset: 5px;
  border-radius: 50%;
  border: 2.5px solid transparent;
  border-top-color: rgba(26, 88, 123, 0.35);
  border-left-color: rgba(26, 88, 123, 0.35);
  animation: spin 1.8s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite reverse;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 120px 32px 40px;
  text-align: center;
}

.empty-icon-wrap {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a587b;
  margin-bottom: 4px;
}

.empty-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.empty-sub {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0;
}

/* ── Section ── */
.section-pad {
  padding: 110px 16px 0;
  max-width: 700px;
  margin: 0 auto;
}

/* ── Content card ── */
.content-card {
  background: #fff;
  border-radius: 16px;
  border: 1.5px solid #e8edf2;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px 24px;
}

/* ── Prose styles for v-html content ── */
.prose {
  font-size: 0.925rem;
  color: #334155;
  line-height: 1.75;
}

.prose >>> h1,
.prose >>> h2,
.prose >>> h3,
.prose >>> h4 {
  color: #0f172a;
  font-weight: 700;
  margin: 1.4em 0 0.5em;
  line-height: 1.3;
}

.prose >>> h1 { font-size: 1.35rem; }
.prose >>> h2 { font-size: 1.15rem; border-bottom: 2px solid #e8edf2; padding-bottom: 8px; }
.prose >>> h3 { font-size: 1rem; color: #1a587b; }

.prose >>> p { margin: 0 0 1em; }

.prose >>> a {
  color: #1a587b;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.prose >>> ul,
.prose >>> ol {
  padding-left: 1.4em;
  margin: 0 0 1em;
}

.prose >>> li { margin-bottom: 0.35em; }

.prose >>> strong { color: #0f172a; font-weight: 700; }

.prose >>> blockquote {
  border-left: 3px solid #1a587b;
  margin: 1em 0;
  padding: 10px 16px;
  background: #f0f8ff;
  border-radius: 0 8px 8px 0;
  color: #475569;
  font-style: italic;
}

.prose >>> img {
  max-width: 100%;
  border-radius: 10px;
  margin: 1em 0;
}

.prose >>> hr {
  border: none;
  border-top: 1.5px solid #e8edf2;
  margin: 1.5em 0;
}
</style>
